import { IncludeExclude, VisibilityState } from '@pages/Employees/interfaces';

const emptyLists = (): IncludeExclude => ({ include: [], exclude: [] });

/** Гарантированно получить списки для атрибута. */
export const getLists = (state: VisibilityState, attribute: string): IncludeExclude => state[attribute] || emptyLists();
